import { position_name } from './config';

export const positionChecking = (view) => {
  switch (view) {
    case position_name['FRONT_LEFT']:
      return true;
    case position_name['FRONT_RIGHT']:
      return true;
    case position_name['REAR_RIGHT']:
      return true;
    case position_name['REAR_LEFT']:
      return true;
    default:
      return false;
  }
};
